<template>
  <div class="obb-selector">
    <AlternativeSelect
      :value="selectedValue"
      :placeholder="$t('APP.RELEASES.OBB.SELECT_OBB')"
      :items="selectorOptions"
      key-prop="id"
      label-prop="name"
      value-prop="id"
      @change="handleValueChange"
    />

    <ObbUploader
      v-if="shouldShowUploader"
      :upload-url="uploadUrl"
      @upload="addUploadedFileToList"
    />
  </div>
</template>

<script>
import AlternativeSelect from '@@/common/AlternativeSelect';
import ObbUploader from './ObbUploader';

const NEUTRAL_OPTIONS = {
  NO_FILE: 'NO_FILE',
  UPLOAD_NEW_FILE: 'UPLOAD_NEW_FILE',
};

export default {
  name: 'ObbSelector',

  components: {
    AlternativeSelect,
    ObbUploader,
  },

  props: {
    value: {
      type: Number,
      default: null,
    },
    files: {
      type: Array,
      required: true,
    },
    uploadUrl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      uploadedFiles: [],
      selectedValue: NEUTRAL_OPTIONS.NO_FILE,
    };
  },

  computed: {
    selectorOptions() {
      return [
        {
          id: NEUTRAL_OPTIONS.NO_FILE,
          name: this.$t('APP.RELEASES.OBB.NO_FILE'),
        },
        ...this.files,
        ...this.uploadedFiles,
        {
          id: NEUTRAL_OPTIONS.UPLOAD_NEW_FILE,
          name: this.$t('APP.RELEASES.OBB.UPLOAD_NEW_FILE'),
        },
      ];
    },

    shouldShowUploader() {
      return this.selectedValue === NEUTRAL_OPTIONS.UPLOAD_NEW_FILE;
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(value = NEUTRAL_OPTIONS.NO_FILE) {
        this.selectedValue = value;
      },
    },
    files() {
      this.uploadedFiles = [];
    },
  },

  methods: {
    addUploadedFileToList(obb) {
      if (obb?.id !== undefined) {
        this.uploadedFiles.push(obb);
        this.handleValueChange(obb.id);
      }
    },

    handleValueChange(newSelectedValue) {
      this.selectedValue = newSelectedValue;

      if (Number.isInteger(newSelectedValue)) {
        this.$emit('change', newSelectedValue);
      } else if (newSelectedValue === NEUTRAL_OPTIONS.NO_FILE) {
        this.$emit('change', null);
      }
    },
  },
};
</script>
